import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path fill=\"#F0F0F0\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#A2001D\" d=\"M3.515 20.485q.758.754 1.604 1.348L21.834 5.118a12.1 12.1 0 0 0-2.952-2.951L2.168 18.881q.593.847 1.347 1.604\"></path><path fill=\"#0052B4\" d=\"M3.514 3.515C-.272 7.3-.998 12.986 1.332 17.502l16.17-16.169C12.986-.997 7.3-.271 3.514 3.515\"></path><path fill=\"#496E2D\" d=\"M20.487 20.485C24.273 16.699 25 11.013 22.67 6.497L6.5 22.667c4.516 2.33 10.202 1.603 13.987-2.182\"></path><path fill=\"#FFDA44\" d=\"m9.914 6.782-1.345.632.716 1.303-1.46-.28-.185 1.475-1.017-1.085-1.017 1.085-.185-1.475-1.46.28.716-1.303-1.345-.632 1.345-.633-.716-1.302 1.46.28.185-1.476 1.017 1.085L7.64 3.651l.185 1.475 1.46-.279-.716 1.302z\"></path>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_7]))
}
export default { render: render }